import { twMerge } from "tailwind-merge"

interface Props {
  text?: string
  className?: string
}

const Divider: React.FC<Props> = ({ text, className = "" }) => {
  return (
    <div
      className={twMerge(
        `
				text-legacy-blu
        relative w-full rounded-full overflow-hidden text-center font-bold min-h-[4px] select-none
        before:absolute before:right-0 before:top-1/2 before:block before:h-0.5 before:w-1/2 before:translate-x-4 before:bg-legacy-blue
        after:absolute after:left-0 after:top-1/2 after:block after:h-0.5 after:w-1/2 after:-translate-x-4 after:bg-legacy-blue
      `,
        className,
      )}
    >
      {!!text && <span>{text}</span>}
    </div>
  )
}

export default Divider
